import styles from './TransferOrders.module.css';
import BasePageStructure from 'src/components/BasePageStructure';
import ConditionalRenderQuery from 'src/components/ConditionalRenderQuery';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { TransferOrdersService } from 'src/pehra-ts-client';
import { useQuery } from '@tanstack/react-query';
import TransferOrderList from './components/TransferOrderList';

export interface ITransferOrders {
  sampleTextProp?: string;
}

const TransferOrders: React.FC<ITransferOrders> = ({ sampleTextProp }) => {
  const fetchTransferOrdersQuery = useQuery({
    queryKey: ['transferOrders'],
    queryFn: () => TransferOrdersService.getAllTransferOrders()
  });

  const transferOrderListComponent = (
    <Box className={styles.employeePositionContainer}>
      <TransferOrderList rows={fetchTransferOrdersQuery.data?.transfer_orders} />
    </Box>
  );

  return (
    <BasePageStructure title="Transfer Order List">
      <Box className={styles.container}>
        <ConditionalRenderQuery
          status={fetchTransferOrdersQuery.status}
          success={() => {
            return transferOrderListComponent;
          }}
        />
      </Box>
    </BasePageStructure>
  );
};

export default TransferOrders;
